import React from 'react';

import { Alert, AlertDescription } from '@zapier/design-system';

const CtaAdminOnlyAccess = () => {
  return (
    <Alert status="warning" title="Admin access only.">
      <AlertDescription>
        Only admins have access to update these settings.
      </AlertDescription>
    </Alert>
  );
};

export default CtaAdminOnlyAccess;
